import { createFileRoute } from '@tanstack/react-router';

import { WalletDollarsPage } from './WalletDollarsPage';

export const Route = createFileRoute('/_protected/_consumer/wallet/dollars/')({
  component: WalletDollarsPage,
});
